import React__default from 'react';
import { View, StyleSheet } from 'react-native';
import { u as useTheme } from './useTheme-c05a5bd5.esm.js';

const AppDot = _ref => {
  let {
    count,
    completedCount,
    forcedValue,
    dotSize = 4,
    dotStyle
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const GenerateColor = p => {
    if (p < 33) return currentTheme?.theme?.red;else if (p >= 33 && p < 100) return currentTheme?.theme?.orangeBtnColor;else if (p === 100) return currentTheme?.theme?.green;
  };
  const styles = styleGenerator({
    currentTheme,
    count,
    completedCount,
    forcedValue,
    GenerateColor,
    dotSize
  });
  return count > 0 || forcedValue ? /*#__PURE__*/React__default.createElement(View, {
    style: [styles.dot, dotStyle]
  }) : null;
};
const styleGenerator = _ref2 => {
  let {
    currentTheme,
    count,
    completedCount,
    forcedValue,
    GenerateColor,
    dotSize
  } = _ref2;
  return StyleSheet.create({
    dot: {
      position: "relative",
      borderRadius: dotSize,
      width: dotSize,
      height: dotSize,
      padding: 2,
      backgroundColor: forcedValue ? GenerateColor(forcedValue * 100) : count > 0 ? GenerateColor(completedCount / count * 100) : GenerateColor(0)
    }
  });
};
AppDot.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppDot",
  "props": {
    "dotSize": {
      "defaultValue": {
        "value": "4",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "When passed, it changes the radius of the dot"
    },
    "count": {
      "required": true,
      "tsType": {
        "name": "number"
      },
      "description": "Count used to logically generate a completion percentage based on completedCount - <completedCount />\n     <count></count>"
    },
    "completedCount": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Count used to logically generate a completion percentage based on the overall count - <completedCount />\n     <count></count>"
    },
    "forcedValue": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "When passed the completedCount and count are overriden by a float between 0 to 1"
    },
    "dotStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style to apply to the dot"
    }
  }
};

export { AppDot as A };
